<template>
  <div :class="{ 'fixed top-6 right-6 z-50': fixed }">
    <themed-button
      @click="toggleTheme"
      variant="ghost"
      size="sm"
      :aria-label="`Switch to ${isDark ? 'light' : 'dark'} mode`"
      :aria-pressed="isDark ? 'true' : 'false'"
      role="switch"
    >
      <theme-icon 
        :icon="isDark ? 'sun' : 'moon'" 
        type="icons" 
        class="w-5 h-5" 
      />
      <span class="text-xs ml-2">{{ isDark ? 'Light' : 'Dark' }}</span>
    </themed-button>
    
    <!-- Screen reader announcement for theme changes -->
    <div 
      role="status" 
      aria-live="polite" 
      aria-atomic="true" 
      class="sr-only"
    >
      {{ announcement }}
    </div>
  </div>
</template>

<script>
import ThemedButton from './v1/ThemedButton.vue';
import ThemeIcon from './v1/ThemeIcon.vue';

export default {
  name: 'ThemeToggle',
  components: {
    ThemedButton,
    ThemeIcon
  },
  props: {
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isDark: false,
      announcement: ''
    }
  },
  mounted() {
    // Check saved preference or default to dark
    const savedTheme = localStorage.getItem('reopt_theme_mode');
    this.isDark = savedTheme ? savedTheme === 'dark' : true;
    this.applyTheme();
  },
  methods: {
    toggleTheme() {
      this.isDark = !this.isDark;
      this.applyTheme();
      localStorage.setItem('reopt_theme_mode', this.isDark ? 'dark' : 'light');
      
      // Announce theme change to screen readers
      this.announcement = `${this.isDark ? 'Dark' : 'Light'} mode activated`;
      
      // Clear announcement after screen reader has time to read it
      setTimeout(() => {
        this.announcement = '';
      }, 1000);
    },
    applyTheme() {
      if (this.isDark) {
        document.documentElement.classList.add('dark');
      } else {
        document.documentElement.classList.remove('dark');
      }
    }
  }
}
</script>

<style scoped>
/* Screen reader only class */
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

/* Responsive adjustments for fixed positioning */
@media (max-width: 640px) {
  .fixed {
    top: 1rem !important;
    right: 1rem !important;
  }
}
</style>
